import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const MagnifyingGlassIcon = ({
  color = 'black',
  width = 14,
  marginRight,
  marginLeft,
  containerSize,
  title,
}: DefaultIconProps) => (
  <DefaultIconWrapper
    marginLeft={marginLeft}
    marginRight={marginRight}
    containerSize={containerSize}
    width={width}
    title={title}
  >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
      <path
        fill={getSemanticTextColor(color)}
        d="M1.426 5.835c0-2.426 1.964-4.401 4.377-4.401s4.376 1.975 4.376 4.4c0 2.428-1.963 4.402-4.376 4.402-2.413 0-4.377-1.974-4.377-4.401m12.227 6.125l-2.968-2.983c.58-.908.921-1.985.921-3.142C11.606 2.618 9.002 0 5.803 0S0 2.618 0 5.835s2.604 5.835 5.803 5.835c1.19 0 2.299-.363 3.221-.985l2.948 2.965c.231.233.535.35.84.35.303 0 .607-.117.841-.35.463-.467.463-1.223 0-1.69"
      />
    </svg>
  </DefaultIconWrapper>
);
